import { generatePdpUrl, useServicesContext, VehicleBasic } from '@oneaudi/vtp-shared';
import { FeatureAppConfig } from '../FeatureHubAppDefinition';
import { useMemo } from 'react';
import { getAppContentConfiguration } from './tileHook';

export const useVehicleDetailsPageUrl = (vehicle: VehicleBasic | undefined) => {
  const servicesContext = useServicesContext();
  const { detailsPageUrlPattern } = getAppContentConfiguration();

  return useMemo(() => {
    if (!vehicle) {
      return undefined;
    }
    if (!detailsPageUrlPattern) {
      return vehicle.entryUrl;
    }
    const featureAppConfig = servicesContext?.featureAppConfig as FeatureAppConfig;
    const seoUrl = generatePdpUrl(
      vehicle.modelYear,
      vehicle.model?.description || vehicle.symbolicCarline?.description!,
      vehicle.id
    );

    return `${featureAppConfig.baseUrl || ''}${detailsPageUrlPattern?.replace(
      'SC_VEHICLE_ID',
      vehicle.id
    )}`.replace('SC_VEHICLE', seoUrl);
  }, [servicesContext, vehicle]);
};
